import Notify from "@/services/Notify";
import Image from "@/services/Image"
import ImageUploadError from "../ImageUploadError"
import Helper from "@/services/Helper";

export function useImageHandler(editorRef, uploadEndpoint, post_id) {
    const insertImage = () => {
        if (!editorRef?.value) return

        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'

        input.onchange = async (event) => {
            const file = event.target.files?.[0]
            if (!file || !editorRef.value) return

            const editor = editorRef.value
            const { schema } = editor.state

            // 1️⃣ вставляем loader
            editor
                .chain()
                .focus()
                .insertContent({
                    type: 'imageLoader',
                })
                .run()

            try {
                const formData = new FormData()
                formData.append('image', file)
                formData.append('post_id', post_id)

                const res = await fetch(uploadEndpoint, {
                    method: 'POST',
                    body: formData,
                })

                if (!res.ok) {
                    // ⬇️ читаем тело ответа
                    const contentType = res.headers.get('content-type')
                    let errorPayload

                    if (contentType?.includes('application/json')) {
                        errorPayload = await res.json()
                    } else {
                        errorPayload = await res.text()
                    }

                    throw new ImageUploadError('Upload failed', {
                        status: res.status,
                        statusText: res.statusText,
                        body: errorPayload,
                        url: res.url,
                    })
                }

                let data = await res.json()
                let item = data?.item
                let host = item?.host
                let name = item?.name

                if (!host || !name) {
                    throw new Error('Отсутствуют значения host и name для формирования картинки')
                }

                const url = Image.handle(host, name, null, null, true)

                if (!url) {
                    throw new Error('No image url')
                }

                // 1. Извлекаем размеры из ответа сервера (если они там есть)
                let width = item?.origin_w || null
                let height = item?.origin_h || null
                
                // 2️⃣ создаём финальную ноду
                const imageNode = schema.nodes.image.create({
                    src: url,
                    width: width,
                    height: height
                })

                const figcaptionNode = schema.nodes.figcaption.create(
                    { 'data-placeholder': 'Подпись к изображению...' },
                    []
                )

                const imageFigureNode = schema.nodes.imageFigure.create(
                    {},
                    [imageNode, figcaptionNode]
                )

                // 3️⃣ НАХОДИМ loader В ДОКУМЕНТЕ и ЗАМЕНЯЕМ
                const { doc } = editor.state
                let loaderPos = null
                let loaderSize = null

                doc.descendants((node, pos) => {
                    if (node.type.name === 'imageLoader') {
                        loaderPos = pos
                        loaderSize = node.nodeSize
                        return false // stop
                    }
                })

                if (loaderPos !== null) {
                    editor
                        .chain()
                        .focus()
                        .command(({ tr }) => {
                            tr.replaceWith(
                                loaderPos,
                                loaderPos + loaderSize,
                                imageFigureNode
                            )
                            return true
                        })
                        .run()
                }

            } catch (e) {
                // ❌ при ошибке — удалить loader
                const { doc } = editor.state

                doc.descendants((node, pos) => {
                    if (node.type.name === 'imageLoader') {
                        editor
                            .chain()
                            .focus()
                            .deleteRange({
                                from: pos,
                                to: pos + node.nodeSize,
                            })
                            .run()

                        return false
                    }
                })

                if (e instanceof ImageUploadError) {
                    let validations = e?.payload?.body?.validations ?? []
                    let errors = getErrors(validations)
                    let firstErr = errors?.[0] ?? null

                    if (Helper.isString(firstErr)) {
                        Notify.error(firstErr)
                    } else {
                        Notify.error("Ошибка загрузки картинки")
                    }
                } else {
                    Notify.error("Ошибка загрузки картинки")
                }
            } finally {
                input.value = ''
            }
        }

        input.click()
    }
   const getErrors = (validations) => {
        let result = []
        Object.values(validations).forEach(value => {
            result.push(value[0])
        })
        return result
    }

    return { insertImage }
}
